import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import { AlertDialog } from "../Components/AlertDialog";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  addEspaceCharacters,
  deleteTableDots,
  functions,
  instance,
  validateFunction,
} from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { LoaderBox } from "../Components/LoaderBox";

function CategoriaDetalle() {
  const [edit, setEdit] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [dialog, setDialog] = React.useState({
    title: "",
    text: "",
  });
  const [openAlertDialog, setOpenAlertDialog] = React.useState(false);
  const [alertDialog, setAlertDialog] = React.useState({
    title: "",
    text: "",
  });
  const [item, setItem] = React.useState({ type: "", id: "", activo: "" });
  const [isLoading, setLoading] = React.useState(true);
  const [items, setItems] = React.useState([]);
  const { user } = useAuth();
  const { state } = useLocation();
  const { id } = state;
  const [categoria, setCategoria] = React.useState({
    id: id,
    nombre: "",
  });
  const navigate = useNavigate();
  deleteTableDots(1);
  function editUnidad(id) {
    navigate("/UnidadEditar", {
      state: {
        id: id
      },
    });
  }
  const update = () => {
    setEdit(true);
  };
  const cancelUpdate = () => {
    setEdit(false);
  };

  const yesClick = () => {
    handleToggle();
    setOpenAlertDialog(false);
  };
  const noClick = () => {
    setOpenAlertDialog(false);
  };

  const disableItem = (type, id, nombre, activo) => {
    setItem({ type: type, id: id, activo: activo });
    setAlertDialog({
      title: "Alerta",
      text: `¿Seguro que deseas ${activo ? "deshabilitar" : "habilitar"} el  ${
        type ? "categoria" : `unidad: ` + nombre
      }?`,
    });
    setOpenAlertDialog(true);
  };
  const columns = React.useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "nombre",
      header: "Nombre",
    },
    {
      accessorKey: "activo",
      header: "Activo",
    },
    {
      accessorFn: (row) => `edit`,
      id: "edit",
      header: "",
      enableColumnFilter: false,
      Cell: ({ renderedCellValue, row }) =>
        validateFunction(user, functions.ModifyProduct) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <Button onClick={() => editUnidad(row.original.id)}>
              <EditTwoToneIcon />
              Editar
            </Button>
          </Box>
        ),
    },
    {
      accessorFn: (row) => `toggle`,
      id: "toggle",
      header: "",
      disableColumnMenu: true,
      Cell: ({ renderedCellValue, row }) =>
        validateFunction(user, functions.ToggleProductState) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <Button
              onClick={() =>
                disableItem(
                  0,
                  row.original.id,
                  row.original.nombre,
                  row.original.activo
                )
              }
              color={row.original.activo ? "error" : "success"}
            >
              {row.original.activo ? "Deshabilitar" : "Habilitar"}
            </Button>
          </Box>
        ),
    },
  ]);
  function populateTable() {
    instance
      .get("/unidad/listByCatalog/" + id)
      .then((res) => {
        setItems(res.data);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  }
  if (isLoading) {
    instance
      .get("/categoria/getById/" + id)
      .then((res) => {
        setCategoria(res.data);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally(
        setTimeout(() => {
          setLoading(false);
        }, 1000)
      );
    populateTable();
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCategoria({
      [name]: value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      id: id,
      nombre: addEspaceCharacters(info.nombre.value),
      userId: user.id,
    };
    instance
      .put("categoria/update", form)
      .then((res) => {
        setDialog({
          title: "Actualización exitosa",
          text: `Se han actualizado los datos del catálogo de forma exitosa.`,
        });
        cancelUpdate();
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  const handleToggle = () => {
    const endpoint = item.type ? "categoria" : "unidad";
    console.log(item);
    instance
      .patch(`/${endpoint}/toggleActivate`, {
        user: user.id,
        id: item.id,
        activo: item.activo,
      })
      .then((res) => {
        setDialog({
          title: "Aviso",
          text: `Se ha actualizado correctamente el estado del ${
            item.type ? "categoria" : "unidad"
          }.`,
        });
        setOpenDialog(true);
        if (item.type) {
          setCategoria({
            ...categoria,
            activo: !categoria.activo,
          });
        } else {
          populateTable();
        }
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxwidth="xl"
        sx={{
          marginTop: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <Grid
            container
            component="form"
            gap={{ xs: "0px", sm: "12px" }}
            onSubmit={handleSubmit}
          >
            <Grid
              item
              xs={12}
              sm={12}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: "12px",
                width: "100%",
              }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="nombre"
                label="Nombre"
                name="nombre"
                value={categoria.nombre}
                autoFocus
                disabled={!edit}
                inputProps={{ maxLength: 50 }}
                onChange={(e) =>
                  setCategoria({ ...categoria, nombre: e.target.value })
                }
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: { xs: "0px", sm: "12px" },
                  width: "100%",
                }}
              >
              {!edit && validateFunction(user, functions.ModifyCategory) && (
                  <Button
                    fullWidth
                    variant="contained"
                    className="warningBg"
                    sx={{ mt: 1, mb: 1 }}
                    onClick={update}
                    hidden={!edit}
                    disabled={!categoria.activo}
                  >
                    Editar
                  </Button>
                )}
                {edit && (
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="success"
                    sx={{ mt: 1, mb: 1 }}
                  >
                    Actualizar
                  </Button>
                )}

                {!edit &&
                validateFunction(user, functions.ToggleCategoryState) && (
                    <Button
                      fullWidth
                      variant="contained"
                      color={categoria.activo ? "error" : "success"}
                      sx={{ mt: 1, mb: 1 }}
                      onClick={() => disableItem(1, id, "", categoria.activo)}
                    >
                      {categoria.activo ? "Deshabilitar" : "Habilitar"}
                    </Button>
                  )}
                {edit && (
                  <Button
                    fullWidth
                    variant="contained"
                    color="error"
                    sx={{ mt: 1, mb: 1 }}
                    onClick={cancelUpdate}
                  >
                    Cancelar
                  </Button>
                )}
              </Grid>
            <Grid item xs={12}>
              <MaterialReactTable
                localization={MRT_Localization_ES}
                columns={columns}
                data={items}
                enableColumnFilterModes={false}
                enableColumnOrdering={false}
                enableGrouping={false}
                enablePinning={false}
                enableRowActions={false}
                initialState={{
                  showColumnFilters: false,
                  columnVisibility: {
                    id: false,
                    activo: false,
                    edit: validateFunction(user, functions.ModifyProduct),
                    toggle: validateFunction(
                      user,
                      functions.ToggleProductState
                    ),
                  },
                }}
                positionToolbarAlertBanner="none"
                enableColumnFilters={false}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enablePagination={true}
                enableTopToolbar={true}
                enableBottomToolbar={true}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
      <AlertDialog
        open={openAlertDialog}
        accept={yesClick}
        acceptText={"Aceptar"}
        decline={noClick}
        declineText={"Cancelar"}
        title={alertDialog.title}
        text={alertDialog.text}
      />
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { CategoriaDetalle };
